var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.646447 1.35355L12.6464 13.3536L13 13L13.3536 12.6464L1.35355 0.646447L1 1L0.646447 1.35355Z",
    stroke: "#183254"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6484 0.646447L0.6484 12.6464L1.00195 13L1.35551 13.3536L13.3555 1.35355L13.002 1L12.6484 0.646447Z",
    stroke: "#183254"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/close_icon.5fdee9f1f73e5da957451cdcde740670.svg";
export { ForwardRef as ReactComponent };